import template from './service_ticket_parts.edit.html';
import controller from './service_ticket_parts.edit.controller';
import './service_ticket_parts.edit.scss';

const serviceTicketsPartsEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default serviceTicketsPartsEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/edit/service_ticket_parts.edit.component.js